import React from 'react';
import './mycss.css'; // Import the style sheet for the modal

const ModalComponent = ({ handleModalConfirm, handleModalCancel }) => {
  return (
    <>
    <div className="custom-overlay" />
    <div className="custom-modal">
      <h2>Permission Required</h2>
      <p>Enter username and password:</p>
      {/* Input fields for username and password */}
      <div>
        <button onClick={handleModalConfirm}>OK</button>
        <button onClick={handleModalCancel}>Cancel</button>
      </div>
    </div>
  </>
  );
};

export default ModalComponent;
